import { ConflictsAction } from "../../../Permissions/UserPermission";
import { satisfies } from "../../../UtilityTypes";
import { Messages } from "../../Messages";
import { FirmSettingsPageDefinition, FirmSettingsSectionDefinition } from "../InternalTypes/FirmSettingsPageDefinition";

/**
 * Represents the reviewer options configuration.
 * @property hitShared - Hits with the selected statuses will be shared to Reviewers.
 * If a hit has a status that has not been selected, it will not be shared to Reviewers.
 * @property statusControl - Choose which statuses will be accessible to Reviewers.
 * If a status is selected, Reviewers can apply it to the hits they have been shared.
 * If a status is not selected, it will not be visible to Reviewers.
 */

export const ReviewerOptionType = {
    HitShared: "hitShared",
    StatusControl: "statusControl"
} as const;

export type ReviewerOptionsTypes = {
    [ReviewerOptionType.HitShared]: string[];
    [ReviewerOptionType.StatusControl]: string[];
};

export const reviewerOptionsSection = satisfies<FirmSettingsSectionDefinition>()({
    name: "reviewer-options",
    displayName: Messages.REVIEWER_OPTIONS,
    defaultValue: {
        [ReviewerOptionType.HitShared]: [],
        [ReviewerOptionType.StatusControl]: []
    },
    type: "handwritten"
} as const);

export const ReviewerOptionsDefinition = satisfies<FirmSettingsPageDefinition>()({
    name: "reviewer-options",
    displayName: Messages.REVIEWER_OPTIONS.getMessage(),
    sections: [reviewerOptionsSection],
    requiredPermission: ConflictsAction.ViewAndUpdateReviewerOptions,
    dataToLoad: ["REVIEWER_OPTIONS"]
} as const);
